import { render } from "./AlertWizard.vue?vue&type=template&id=7f739c02&ts=true"
import script from "./AlertWizard.vue?vue&type=script&lang=ts"
export * from "./AlertWizard.vue?vue&type=script&lang=ts"

import "./AlertWizard.vue?vue&type=style&index=0&id=7f739c02&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__